module.exports = __webpack_public_path__ + "img/japan-cardiovascular-diseases-female.ae54c225.png";